import { saveUserSetting } from "@/shared/stores/saveUserSetting";
import { userSettingsStore } from "@/shared/stores/UserSettingsStore";
import { makeAutoObservable, runInAction } from "mobx";

const SECTION = "trading-preferences";
const KEY = "adaptive-amount";

class AdaptiveAmountStore {
  enabled = false;
  loaded = false;
  private loadPromise: Promise<void> | null = null;
  private settingIdRef: { current: string | null } = { current: null };

  constructor() {
    makeAutoObservable(this, { settingIdRef: false, loadPromise: false } as any);
  }

  load(): Promise<void> {
    if (this.loaded) return Promise.resolve();
    if (this.loadPromise) return this.loadPromise;

    this.loadPromise = userSettingsStore.load().then(() => {
      const entry = userSettingsStore.getSetting(SECTION, KEY);
      const value = entry?.value as { enabled?: unknown } | undefined;
      runInAction(() => {
        this.settingIdRef.current = entry?.id ?? null;
        this.enabled = value?.enabled === true;
        this.loaded = true;
      });
      this.loadPromise = null;
    });

    return this.loadPromise;
  }

  setEnabled(enabled: boolean) {
    runInAction(() => {
      this.enabled = enabled;
    });
    void saveUserSetting(SECTION, KEY, { enabled }, this.settingIdRef);
  }
}

export const adaptiveAmountStore = new AdaptiveAmountStore();
